import React, { createContext, FC, useContext } from 'react';

export const TriggerRunContext = createContext<() => void>(() => {});

interface TriggerRunContextProviderProps {
    triggerRun: () => void;
    children: React.ReactNode;
}

export const TriggerRunContextProvider: FC<TriggerRunContextProviderProps> = props => {
    return <TriggerRunContext.Provider value={props.triggerRun}>{props.children}</TriggerRunContext.Provider>;
};

export function useTriggerRun() {
    return useContext(TriggerRunContext);
}
